import React, { FC, useState } from 'react';
import { Box, Typography, Fade, useMediaQuery } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { IFlattenedPhotoItem } from '../../../../models/phases-of-contruction';
import { Modal } from '../../../../components';

interface IBuildPhotoModalProps {
  selectedPhoto: IFlattenedPhotoItem | null;
  onClose: () => void;
}

export const BuildPhotoModal: FC<IBuildPhotoModalProps> = ({ selectedPhoto, onClose }) => {
  const classes = useStyles();
  const [imageLoading, setImageLoading] = useState<boolean>(false);
  const isMobile = useMediaQuery('(max-width:768px)');

  const handleImageLoad = () => {
    setImageLoading(false);
  };

  const handleCloseModal = () => {
    setImageLoading(false);
    onClose();
  };

  return (
    <Modal open={!!selectedPhoto} onClose={handleCloseModal} maxWidth="md" transitionDuration={300}>
      <Fade in={!!selectedPhoto}>
        <Box className={classes.modalContent}>
          {selectedPhoto && (
            <>
              <Box
                display="flex"
                justifyContent="center"
                className={classes.imageContainer}
                sx={{ padding: isMobile ? 2 : 3 }}
              >
                <img
                  src={selectedPhoto.photoUrl}
                  alt={selectedPhoto.originalFileName || 'Build photo'}
                  className={classes.modalImage}
                  onLoad={handleImageLoad}
                  style={{ opacity: imageLoading ? 0 : 1 }}
                />
              </Box>

              {selectedPhoto.comment && (
                <Box mt={1} p={2} className={classes.commentContainer}>
                  <Typography variant="body2" color="textSecondary" gutterBottom>
                    <em>Comment:</em>
                  </Typography>
                  <Typography variant="body1">{selectedPhoto.comment}</Typography>
                </Box>
              )}
            </>
          )}
        </Box>
      </Fade>
    </Modal>
  );
};

const useStyles = makeStyles(theme => ({
  modalContent: {
    backgroundColor: '#fff',
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1),
    maxHeight: '85vh',
    overflow: 'hidden',
    minHeight: '400px',
    display: 'flex',
    flexDirection: 'column'
  },
  imageContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '50vh',
    maxHeight: '60vh',
    flex: '1 1 auto',
    overflow: 'hidden'
  },
  modalImage: {
    maxWidth: '100%',
    maxHeight: '100%',
    width: 'auto',
    height: 'auto',
    objectFit: 'contain',
    transition: 'opacity 0.3s ease-in-out',
    padding: theme.spacing(1)
  },
  commentContainer: {
    borderTop: `1px solid ${theme.palette.grey[300]}`,
    backgroundColor: theme.palette.grey[50],
    flex: '0 0 auto',
    maxHeight: '20vh',
    overflowY: 'auto'
  }
}));
